import { authenticatedRequest } from './authApi';
import { REST_API_ORIGIN } from '../platform/endpoints';
const API_BASE = REST_API_ORIGIN;

async function req(path, { method = 'GET', body } = {}) {
  let res;
  try {
    res = await authenticatedRequest(`${API_BASE}${path}`, {
      rawResponse: true,
      method,
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      },
      body,
      credentials: 'include',
      diagSource: 'chatApi',
    });
  } catch (e) {
    if (e?.status) throw e;
    const err = new Error('Network error');
    err.cause = e;
    err.status = 0;
    throw err;
  }
  if (res.status === 204) return { ok: true };

  const contentType = res.headers.get('content-type') || '';
  let data = null;
  if (/application\/json/i.test(contentType)) {
    try { data = await res.json(); } catch {}
  } else {
    try {
      const text = await res.text();
      if (text) data = { message: text };
    } catch {}
  }
  if (!res.ok) {
    const err = new Error((data && (data.message || data.error)) || `HTTP ${res.status}`);
    err.status = res.status;
    err.payload = data;
    throw err;
  }
  return data ?? { ok: true };
}

export async function listConversations(token) {
  void token;
  return req('/api/chat/conversations');
}

export async function getConversation(token, conversationId) {
  void token;
  return req(`/api/chat/conversations/${encodeURIComponent(conversationId)}`);
}

// NUEVO: info del peer (coincide con backend /api/chat/...)
export async function getConversationInfo(token, conversationId) {
  void token;
  return req(`/api/chat/conversations/${encodeURIComponent(conversationId)}/info`);
}

function toISO(d) {
  if (!d) return undefined;
  try {
    const dd = (d instanceof Date) ? d : new Date(d);
    if (Number.isNaN(dd.getTime())) return undefined;
    return dd.toISOString();
  } catch { return undefined; }
}

export async function getMessages(token, conversationId, { limit, before } = {}) {
  void token;
  const params = new URLSearchParams();
  if (limit) params.set('limit', String(limit));
  const isoBefore = toISO(before);
  if (isoBefore) params.set('before', isoBefore);
  const qs = params.toString() ? `?${params.toString()}` : '';

  // Primary route (current backend)
  const primary = `/api/chat/${encodeURIComponent(conversationId)}/messages${qs}`;
  try {
    return await req(primary);
  } catch (err) {
    // Fallback: try legacy route only on 404
    if (err && Number(err.status) === 404) {
      const legacy = `/api/chat/conversations/${encodeURIComponent(conversationId)}/messages${qs}`;
      return await req(legacy);
    }
    throw err;
  }
}

export async function getConversationMessages(tokenOrConversationId, maybeConversationId, opts = {}) {
  if (typeof maybeConversationId === 'string' && maybeConversationId.trim()) {
    return getMessages(tokenOrConversationId, maybeConversationId, opts);
  }

  if (maybeConversationId && typeof maybeConversationId === 'object' && !Array.isArray(maybeConversationId)) {
    throw new Error('getConversationMessages firma inválida: usá (conversationId, opts) o (token, conversationId, opts)');
  }

  return getMessages(undefined, tokenOrConversationId, opts || {});
}

export async function openOrCreateConversation(token, friendId) {
  void token;
  return req('/api/chat/open', { method: 'POST', body: { friendId } });
}

export async function sendMessage(token, conversationId, { text, attachments } = {}) {
  void token;
  return req(`/api/chat/${encodeURIComponent(conversationId)}/messages`, {
    method: 'POST',
    body: { text, attachments: attachments || [] },
  });
}

export async function markAsRead(token, conversationId, messageIds) {
  void token;
  return req(`/api/chat/${encodeURIComponent(conversationId)}/read`, {
    method: 'POST',
    body: { messageIds: Array.isArray(messageIds) ? messageIds : [] },
  });
}
